// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"36049f14","845":"db82ac75"}[chunkId] + ".chunk.js";
};